import { get, post, put } from "aws-amplify/api";
import { API_ENDPOINTS } from "./client";
import webStorage from "utils/webStorage";

export const getFuneralListAPI = async values => {
  try {
    const options = {
      queryParams: {
        ...values,
      },
    };

    const getFunerals = get({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: `/reception/funerals`,
      options: options,
    });

    const { body } = await getFunerals.response;
    const response = await body.json();

    return response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

export const getVigilListAPI = async values => {
  try {
    const options = {
      queryParams: {
        ...values,
      },
    };

    const getVigils = get({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: `/reception/vigils`,
      options: options,
    });

    const { body } = await getVigils.response;
    const response = await body.json();

    return response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

export const getFuneralDetailAPI = async values => {
  try {
    const options = {
      queryParams: {
        ...values,
      },
    };

    const getFuneral = get({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: `/funerals/${values?.funeralId}`,
      options: options,
    });

    const { body } = await getFuneral.response;
    const response = await body.json();

    return response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

export const getHallListAPI = async values => {
  try {
    const options = {
      queryParams: {
        ...values,
      },
    };

    const getHalls = get({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: `/reception/halls`,
      options: options,
    });

    const { body } = await getHalls.response;
    const response = await body.json();
    return response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

export const getAddressAPI = async formData => {
  try {
    formData.append(
      "targetUrl",
      "https://www.keicho.net/api/AddressInformation/v1/addressInformation.php"
    );
    const options = {
      body: formData,
    };

    const getAddress = post({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: `/sagawa-api-proxy`,
      options: options,
    });

    const { body } = (await getAddress?.response) || { body: null };
    return body?.text() || "";
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

/**
 * 葬儀社設定の取得（領収書印刷機能 + 供花供物手動登録機能 + その他）
 * @param {string} companyId - 葬儀社ID
 * @returns {Promise<Object>} 葬儀社設定情報
 */
export const getCompanySettingsApi = async companyId => {
  try {
    const options = {
      queryParams: { companyId },
    };

    const getCompanySettings = get({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: `/companies/${companyId}`,
      options: options,
    });

    const { body } = await getCompanySettings.response;
    const response = await body.json();

    return response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

export const updateFuneralCondolenceGiftSymbolListApi = async (
  funeralId,
  companyId,
  isCondolenceGiftSymbolVisible,
  condolenceGiftSymbolList
) => {
  try {
    const options = {
      body: {
        funeralId,
        companyId,
        isCondolenceGiftSymbolVisible,
        condolenceGiftSymbolList,
      },
    };

    const updateFuneralCondolenceGiftSymbolList = put({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: "/reception/funerals/update-funeral-condolence-gift-symbol-list",
      options: options,
    });

    await updateFuneralCondolenceGiftSymbolList?.response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

/**
 * 供花・供物・弔電集計用に「CSVダウンロード済みフラグ」を更新するAPI呼び出し関数
 * @param {string} funeralId - 葬家ID
 * @param {string} companyId - 葬儀社ID
 * @returns {Promise<void>}
 */
export const updateFuneralIsItemCsvDownloadApi = async (funeralId, companyId) => {
  try {
    const options = {
      body: {
        funeralId,
        companyId,
      },
    };

    const updateFuneralIsItemCsvDownload = put({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: "/reception/funerals/update-funeral-is-item-csv-download",
      options: options,
    });

    await updateFuneralIsItemCsvDownload?.response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

/**
 * 参列のしおり PDF の生成・取得（services/funeral の downloadShiori）。
 *
 * - 成功: { url }（IMAGE_BUCKET_URL 込みの完全URL）。9pt まで自動縮小しても
 *   罫線に収まらなかった列がある場合は overflowedFields が付く（spec 5.3）。
 *   出力自体は成功しているため、呼び出し側は警告表示に留める。
 * - 必須項目不足: 400 + { error, missingFields }（spec 2.3）。
 *
 * 受付管理ログイン画面（未ログイン状態）から呼ばれるため、他の関数のような
 * 401/403 でのログイン画面へのリダイレクトは行わない（既に当該画面にいるため、
 * リダイレクトしても意味がなく、ログイン操作を妨げるだけになる）。
 * downloadShiori 側も API Gateway の authorizer を持たない。
 */
export const downloadShioriAPI = async (funeralId, format) => {
  try {
    const getShiori = get({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: `/funerals/${funeralId}/download/shiori`,
      options: { queryParams: { format } },
    });

    const { body } = await getShiori.response;

    return await body.json();
  } catch (e) {
    // services/apis の慣習に合わせ、解決済みレスポンス({ statusCode, headers, body })を投げる。
    // 解決できない場合(ネットワーク断など)は元のエラーをそのまま投げる。
    const error = await e?.response;
    throw error ?? e;
  }
};
